<template>
  <div v-bind:style="{height: getTotalHeight()}" class="home_class">
    <!-- <div style="position: fixed; top: 0px; left: 0px; width: 100%; height: 60px; background-color: #3458A4; z-index: 1030; cursor: pointer;" @click="goEvent()">
      <div v-bind:style="{'background-image': `url('${getBannerImg()}')`, width: '100%', height: '100%', 'background-size': 'contain', 'background-position': 'center center', 'background-repeat': 'no-repeat'}">
      </div>
    </div>     -->
    <div>
      <div
        v-bind:style="{
          position: 'absolute',
          left: '0px',
          top: '0px',
          position: 'absolute',
          'z-index': -1,
          'background-image': `url('/img/bg_main_land_2.png')`,
          'background-size': 'cover',
          'background-position': 'center center',
          'background-repeat': 'no-repeat',
          width: '100%',
          height: getTopMargin2(),
        }"
      ></div>
      <!-- <div
        v-bind:style="{position:'absolute', left:'0px', top:getTopMargin2(), position: 'absolute', 'z-index': -1,
      'background-color': '#111736',
        width: '100%',
        height: '518px'}"
      ></div> -->
      <!-- <parallax v-bind:useScroll=false class="page-header-image" style="background-image:url('/img/img_main_home.png')"></parallax> -->
      <div
        v-if="$store.state.account.saleStatus == 'pre'"
        style="text-align: center"
      >
        <div
          style="
            position: absolute;
            left: 0px;
            top: 770px;
            position: absolute;
            z-index: -2;
            background-color: #0e3a63;
            width: 100%;
            height: 340px;
          "
        ></div>
        <div
          style="
            position: absolute;
            left: 0px;
            top: 1110px;
            position: absolute;
            z-index: -2;
            background-color: #041127;
            width: 100%;
            height: 700px;
          "
        >
          <div class="--circle-11525c">
            <img src="img/icon-land.png" class="icon_land" />
          </div>
        </div>
        <div
          style="
            position: absolute;
            left: 10px;
            top: 140px;
            text-align: center;
            height: 580px;
            width: calc(100% - 20px);
          "
        >
          <div
            style="
              width: 100%;
              height: 100%;
              background-color: #090911;
              opacity: 0.7;
            "
          ></div>
          <div
            style="
              position: absolute;
              top: -10px;
              text-align: center;
              width: 100%;
            "
          >
            <span class="LAND-MAIN-SALE-2"> LAND MAIN SALE #2 </span>
          </div>
          <div
            style="
              position: absolute;
              top: 40px;
              text-align: center;
              width: 100%;
            "
          >
            <span
              class="
                Land-Main-Sale-2-will-be-open-soon-Own-the-Land-of-the-League
              "
              >Land Main Sale #2 is coming soon<br />
              Own the Land & Start your metaverse journey!</span
            >
          </div>
          <div
            style="position: absolute; top: 120px; width: 100%; height: 40px"
          >
            <div
              style="position: absolute; left: 0px; width: 100%; height: 40px"
            >
              <div class="Rectangle-22-copy-7"></div>
              <span
                class="-UTC-0000-318-UTC-2359-48-hours"
                style="margin-left: 110px"
              >
                3/17 UTC 00:00 ~ 3/18 UTC 23:59 (48 hours)
              </span>
            </div>
            <div
              style="position: absolute; left: 0px; width: 100%; height: 40px"
            >
              <div class="Rectangle-22-copy-6">
                <span class="Dutch-auction"> Dutch auction </span>
              </div>
            </div>
          </div>
          <div
            style="position: absolute; top: 160px; width: 100%; height: 40px"
          >
            <div
              style="position: absolute; left: 0px; width: 100%; height: 40px"
            >
              <div class="Rectangle-22-copy-7"></div>
              <span
                class="-UTC-0000-318-UTC-2359-48-hours"
                style="margin-left: 110px"
              >
                3/19 UTC 00:00 ~ 3/19 UTC 23:59 (24 hours)
              </span>
            </div>
            <div style="position: absolute; left: 0px">
              <div class="Rectangle-22-copy-6">
                <span class="Dutch-auction"> Guild round </span>
              </div>
            </div>
          </div>
          <div
            style="position: absolute; top: 200px; width: 100%; height: 40px"
          >
            <div
              style="position: absolute; left: 0px; width: 100%; height: 40px"
            >
              <div class="Rectangle-22-copy-7"></div>
              <span
                class="-UTC-0000-318-UTC-2359-48-hours"
                style="margin-left: 110px"
              >
                3/20 UTC 00:00 ~ 3/24 UTC 23:59 (96 hours)
              </span>
            </div>
            <div style="position: absolute; left: 0px">
              <div class="Rectangle-22-copy-6">
                <span class="Dutch-auction"> Public round </span>
              </div>
            </div>
          </div>
          <div style="position: absolute; top: 260px; left: calc(50% - 180px)">
            <img
              src="/img/deco_sale.png"
              style="width: 360px; object-fit: contain"
            />
          </div>
          <div style="position: absolute; top: 300px; left: calc(50% - 160px)">
            <flip-countdown
              deadtype="dutch-start"
              v-bind:labels="labels"
              style="
                padding-left: 0px !important;
                padding-right: 0px !important;
              "
            ></flip-countdown>
          </div>
          <div
            style="
              position: absolute;
              top: 360px;
              text-align: center;
              height: 170px;
              width: calc(100% - 20px);
              z-index: 1;
              left: 10px;
            "
          >
            <div
              class="--btn_01"
              style="position: absolute; left: 0px; top: 60px"
              @click="goLand()"
            >
              <span class="ABOUT-LAND"> ABOUT LAND 3.0 </span>
              <img src="/img/icon-arr.png" class="icon_arr" />
            </div>
            <div
              class="--btn_01"
              style="position: absolute; left: 0px; top: 150px"
              @click="goAboutMainSale()"
            >
              <span class="ABOUT-LAND"> ABOUT LAND SALE #2 </span>
              <img src="/img/icon-arr.png" class="icon_arr" />
            </div>
          </div>
        </div>
        <div
          style="
            position: absolute;
            left: 0px;
            top: 770px;
            position: absolute;
            width: 100%;
            height: 640px;
          "
        >
          <div
            style="
              position: absolute;
              top: 50px;
              width: 100%;
              text-align: center;
            "
          >
            <span class="LOKA-Purchase-Bonus"> LOKA Purchase Bonus </span>
          </div>
          <div
            style="
              position: absolute;
              top: 124px;
              width: 100%;
              text-align: center;
            "
          >
            <span
              class="
                If-you-purchase-Rand-with-LOKA-you-can-get-additional-bonuses
              "
            >
              Purchase your Land with $LOKA<br />
              Enjoy additional bonuses depending on the amount.
            </span>
          </div>
          <div
            style="
              position: absolute;
              top: 210px;
              width: 100%;
              text-align: center;
            "
          >
            <div class="Rectangle-20-copy" @click="goLokaPurchasBonus()">
              <span class="Check-My-Bonus"> Check My Bonus </span>
              <img src="/img/icon-arr.png" class="icon_arr" />
            </div>
          </div>
        </div>
        <div
          style="
            position: absolute;
            left: 0px;
            top: 1110px;
            position: absolute;
            width: 100%;
            height: 700px;
          "
        >
          <div
            style="
              position: absolute;
              top: 50px;
              width: 80%;
              left: 10%;
              text-align: center;
            "
          >
            <span
              class="
                In-the-first-24-hours-of-Land-Main-Sale-2-only-Land-of-Level
              "
            >
              The auction price drop scale is 12.5% of the Floor Price of each
              level of LAND,<br />
              and will descend every hour for 48 installments.<br />
              After dutch aution, Land Main Sale #2 will be held with a fixed
              price.
            </span>
          </div>
          <div class="land_class">
            <table>
              <tr height="70px">
                <th width="16%">Land level</th>
                <th width="28%">Start price</th>
                <th width="28%">Floor price</th>
                <th width="28%"># of Lands</th>
              </tr>
              <tr height="80px">
                <td width="16%">Lv. 6</td>
                <td width="28%">$28,000</td>
                <td width="28%">$4,000</td>
                <td width="28%">46</td>
              </tr>
              <tr height="80px">
                <td width="16%" style="background-color: #d2d9e1">Lv. 5</td>
                <td width="28%" style="background-color: #d2d9e1">$12,250</td>
                <td width="28%" style="background-color: #d2d9e1">$1,750</td>
                <td width="28%" style="background-color: #d2d9e1">179</td>
              </tr>
              <tr height="80px">
                <td width="16%">Lv. 4</td>
                <td width="28%">$6,300</td>
                <td width="28%">$900</td>
                <td width="28%">646</td>
              </tr>
              <tr height="80px">
                <td width="16%" style="background-color: #d2d9e1">Lv. 3</td>
                <td width="28%" style="background-color: #d2d9e1">$3,500</td>
                <td width="28%" style="background-color: #d2d9e1">$500</td>
                <td width="28%" style="background-color: #d2d9e1">1,328</td>
              </tr>
              <tr height="80px">
                <td width="16%">Lv. 2</td>
                <td width="28%">$3,150</td>
                <td width="28%">$450</td>
                <td width="28%">1,269</td>
              </tr>
              <tr height="80px">
                <td width="16%" style="background-color: #d2d9e1">Lv. 1</td>
                <td width="28%" style="background-color: #d2d9e1">$2,450</td>
                <td width="28%" style="background-color: #d2d9e1">$350</td>
                <td width="28%" style="background-color: #d2d9e1">2,554</td>
              </tr>
            </table>
          </div>
        </div>
      </div>
      <div
        v-if="$store.state.account.saleStatus == 'dutch'"
        style="text-align: center"
      >
        <div
          style="
            position: absolute;
            left: 0px;
            top: 770px;
            position: absolute;
            z-index: -2;
            background-color: #0e3a63;
            width: 100%;
            height: 380px;
          "
        ></div>
        <div
          style="
            position: absolute;
            left: 0px;
            top: 1150px;
            position: absolute;
            z-index: -2;
            background-color: #041127;
            width: 100%;
            height: 720px;
          "
        >
          <div class="--circle-11525c">
            <img src="img/icon-land.png" class="icon_land" />
          </div>
        </div>
        <div
          style="
            position: absolute;
            left: 10px;
            top: 140px;
            text-align: center;
            height: 580px;
            width: calc(100% - 20px);
          "
        >
          <div
            style="
              width: 100%;
              height: 100%;
              background-color: #090911;
              opacity: 0.7;
            "
          ></div>
          <div
            style="
              position: absolute;
              top: -10px;
              text-align: center;
              width: 100%;
            "
          >
            <span class="LAND-MAIN-SALE-2"> LAND MAIN SALE #2 </span>
          </div>
          <div
            style="
              position: absolute;
              top: 40px;
              text-align: center;
              width: 100%;
            "
          >
            <span
              class="
                Land-Main-Sale-2-will-be-open-soon-Own-the-Land-of-the-League
              "
              >Land Sale #2 (Dutch Auction) has begun.<br />Price descends every
              hour.</span
            >
          </div>
          <div
            class="btn_bg"
            style="
              position: absolute;
              top: 120px;
              left: 20px;
              width: calc(100% - 40px);
              cursor: pointer;
              text-align: center;
            "
            @click="goToMainsale()"
          >
            <span class="ABOUT-LAND" style="font-size: 24px">
              Join Landsale
            </span>
            <img src="/img/icon-arr.png" class="icon_arr2" />
          </div>
          <div class="price_class" style="top: 220px;">
            <table>
              <tr height="60px">
                <th width="25%"></th>
                <th width="25%" style="color: #fff">Start</th>
                <th width="25%" style="background-color: #fff; color: #0072ff">
                  Current
                </th>
                <th width="25%" style="color: #fff">Floor</th>
                <!-- <th
                    width="150px"
                    v-for="(remainLand, index0) in remainLands"
                    v-bind:key="index0"
                  >
                    <span v-if="remainLand.remain > 0">
                      Level {{ 6 - index0 }}
                    </span>
                    <img
                      style="margin-top: -4px"
                      v-if="remainLand.remain == 0"
                      v-bind:src="`img/lv-${6 - index0}-soldout.png`"
                    />
                  </th> -->
              </tr>
              <tr
                height="60px"
                v-for="(price1, index1) in prices[0]"
                v-bind:key="index1"
              >
                <td width="25%" style="color: #ebcc1d">
                  <img
                    style="margin-top: -4px"
                    v-if="remainLands[index1].remain == 0"
                    v-bind:src="`img/lv-${6 - index1}-soldout.png`"
                  />
                  <span v-if="remainLands[index1].remain > 0"
                    >LV {{ 6 - index1 }}</span
                  >
                </td>
                <td width="25%">${{ prices[0][index1].toFixed(2) | comma }}</td>
                <td width="25%" style="background-color: #fff; color: #0072ff">
                  ${{ prices[1][index1].toFixed(2) | comma }}
                </td>
                <td width="25%">${{ prices[2][index1].toFixed(2) | comma }}</td>
              </tr>
            </table>
          </div>
        </div>
        <div
          style="
            position: absolute;
            top: 902px;
            text-align: center;
            height: 350px;
            width: 100%;
            z-index: 2;
          "
        >
          <div
            style="position: absolute; top: -20px; width: 100%; height: 29px"
          >
            <span class="Remaining-Time">Remaining Time</span>
          </div>
          <div style="position: absolute; top: 30px; left: calc(50% - 160px)">
            <flip-countdown
              deadtype="dutch-end"
              v-bind:labels="labels"
              style="
                padding-left: 0px !important;
                padding-right: 0px !important;
              "
            ></flip-countdown>
          </div>
          <div
            style="
              position: absolute;
              top: 150px;
              left: calc(50% - 150px);
              width: 300px;
              height: 40px;
            "
            class="img_salebar_bg"
          >
            <div
              v-bind:style="{
                position: 'absolute',
                top: '0px',
                left: '0px',
                overflow: 'hidden',
                height: '40px',
                width: `${saleRate * 100}%`,
              }"
            >
              <img
                src="img/img-salebar.png"
                style="
                  position: absolute;
                  top: 0px;
                  left: 0px;
                  width: 300px;
                  height: 40px;
                  max-width: none;
                "
              />
            </div>
            <span class="-Sale text-stroke"
              >{{ (saleRate * 100).toFixed(2) }}% Sold</span
            >
          </div>
        </div>
        <div
          style="
            position: absolute;
            left: 0px;
            top: 1180px;
            position: absolute;
            width: 100%;
            height: 640px;
          "
        >
          <div
            style="
              position: absolute;
              top: 50px;
              width: 100%;
              text-align: center;
            "
          >
            <span class="LOKA-Purchase-Bonus"> LOKA Purchase Bonus </span>
          </div>
          <div
            style="
              position: absolute;
              top: 124px;
              width: 100%;
              text-align: center;
            "
          >
            <span
              class="
                If-you-purchase-Rand-with-LOKA-you-can-get-additional-bonuses
              "
            >
              Purchase your Land with $LOKA<br />
              Enjoy additional bonuses depending on the amount.
            </span>
          </div>
          <div
            style="
              position: absolute;
              top: 210px;
              width: 100%;
              text-align: center;
            "
          >
            <div class="Rectangle-20-copy" @click="goLokaPurchasBonus()">
              <span class="Check-My-Bonus"> Check My Bonus </span>
              <img src="/img/icon-arr.png" class="icon_arr" />
            </div>
          </div>
        </div>
        <div
          style="
            position: absolute;
            top: 1460px;
            text-align: center;
            height: 170px;
            width: calc(100% - 40px);
            z-index: 1;
            left: 20px;
          "
        >
          <div
            class="--btn_02"
            style="position: absolute; left: 0px; top: 60px"
            @click="goLand()"
          >
            <span class="ABOUT-LAND"> ABOUT LAND 3.0 </span>
            <img src="/img/icon-arr.png" class="icon_arr" />
          </div>
          <div
            class="--btn_02"
            style="position: absolute; left: 0px; top: 150px"
            @click="goAboutMainSale()"
          >
            <span class="ABOUT-LAND"> ABOUT LAND SALE #2 </span>
            <img src="/img/icon-arr.png" class="icon_arr" />
          </div>
        </div>
      </div>
      <div
        v-if="$store.state.account.saleStatus == 'guild'"
        style="text-align: center"
      >
        <div
          style="
            position: absolute;
            left: 0px;
            top: 770px;
            position: absolute;
            z-index: -2;
            background-color: #0e3a63;
            width: 100%;
            height: 380px;
          "
        ></div>
        <div
          style="
            position: absolute;
            left: 0px;
            top: 1150px;
            position: absolute;
            z-index: -2;
            background-color: #041127;
            width: 100%;
            height: 720px;
          "
        >
          <div class="--circle-11525c">
            <img src="img/icon-land.png" class="icon_land" />
          </div>
        </div>
        <div
          style="
            position: absolute;
            left: 10px;
            top: 140px;
            text-align: center;
            height: 580px;
            width: calc(100% - 20px);
          "
        >
          <div
            style="
              width: 100%;
              height: 100%;
              background-color: #090911;
              opacity: 0.7;
            "
          ></div>
          <div
            style="
              position: absolute;
              top: -10px;
              text-align: center;
              width: 100%;
            "
          >
            <span class="LAND-MAIN-SALE-2"> LAND MAIN SALE #2 </span>
          </div>
          <div
            style="
              position: absolute;
              top: 40px;
              text-align: center;
              width: 100%;
            "
          >
            <span
              class="
                Land-Main-Sale-2-will-be-open-soon-Own-the-Land-of-the-League
              "
              >Land Sale #2 (Guild round) has begun.</span
            >
          </div>
          <div
            class="btn_bg"
            style="
              position: absolute;
              top: 120px;
              left: 20px;
              width: calc(100% - 40px);
              cursor: pointer;
              text-align: center;
            "
            @click="goToMainsale()"
          >
            <span class="ABOUT-LAND" style="font-size: 24px">
              Join Landsale
            </span>
            <img src="/img/icon-arr.png" class="icon_arr2" />
          </div>
          <div class="price_class" style="top: 220px;">
            <table>
              <tr height="60px">
                <th width="40%"></th>
                <th width="60%" style="color: #fff">Current</th>
                <!-- <th
                    width="150px"
                    v-for="(remainLand, index0) in remainLands"
                    v-bind:key="index0"
                  >
                    <span v-if="remainLand.remain > 0">
                      Level {{ 6 - index0 }}
                    </span>
                    <img
                      style="margin-top: -4px"
                      v-if="remainLand.remain == 0"
                      v-bind:src="`img/lv-${6 - index0}-soldout.png`"
                    />
                  </th> -->
              </tr>
              <tr
                height="60px"
                v-for="(price1, index1) in prices[0]"
                v-bind:key="index1"
              >
                <td width="40%" style="color: #ebcc1d">
                  <img
                    style="margin-top: -4px"
                    v-if="remainLands[index1].remain == 0"
                    v-bind:src="`img/lv-${6 - index1}-soldout.png`"
                  />
                  <span v-if="remainLands[index1].remain > 0"
                    >LV {{ 6 - index1 }}</span
                  >
                </td>
                <td width="60%">${{ prices[1][index1].toFixed(2) | comma }}</td>
              </tr>
            </table>
          </div>
        </div>
        <div
          style="
            position: absolute;
            top: 902px;
            text-align: center;
            height: 350px;
            width: 100%;
            z-index: 2;
          "
        >
          <div
            style="position: absolute; top: -20px; width: 100%; height: 29px"
          >
            <span class="Remaining-Time">Remaining Time</span>
          </div>
          <div style="position: absolute; top: 20px; left: calc(50% - 160px)">
            <flip-countdown
              deadtype="guild-end"
              v-bind:labels="labels"
              style="
                padding-left: 0px !important;
                padding-right: 0px !important;
              "
            ></flip-countdown>
          </div>
          <div
            style="
              position: absolute;
              top: 120px;
              left: calc(50% - 150px);
              width: 300px;
              height: 40px;
            "
            class="img_salebar_bg"
          >
            <div
              v-bind:style="{
                position: 'absolute',
                top: '0px',
                left: '0px',
                overflow: 'hidden',
                height: '40px',
                width: `${saleRate * 100}%`,
              }"
            >
              <img
                src="img/img-salebar.png"
                style="
                  position: absolute;
                  top: 0px;
                  left: 0px;
                  width: 300px;
                  height: 40px;
                  max-width: none;
                "
              />
            </div>
            <span class="-Sale text-stroke"
              >{{ (saleRate * 100).toFixed(2) }}% Sold</span
            >            
          </div>
          <div style="position: absolute; top: 170px; width: 100%; height: 20px; text-align: center;">
              <span v-if="$store.state.account.wallet != null && numRemainInWhiteList > 0" style="font-size: 15px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.4;
  letter-spacing: normal;
  text-align: center;
  color: #6e8ec7;">Available quantity : {{numRemainInWhiteList}}</span>
            <span v-if="$store.state.account.wallet != null && numRemainInWhiteList == 0" style="font-size: 15px;
            font-weight: 500;
            font-stretch: normal;
            font-style: normal;
            line-height: 2.4;
            letter-spacing: normal;
            text-align: center;
            color: #ff0000;">You are not whitelisted</span>
              <span v-if="$store.state.account.wallet == null" style="font-size: 15px;
              font-weight: 500;
              font-stretch: normal;
              font-style: normal;
              line-height: 2.4;
              letter-spacing: normal;
              text-align: center;
              color: #ff0000;">Please connect your whitelisted Ethereum wallet.</span>
            </div>
        </div>
        
        <div
          style="
            position: absolute;
            left: 0px;
            top: 1180px;
            position: absolute;
            width: 100%;
            height: 640px;
          "
        >
          <div
            style="
              position: absolute;
              top: 50px;
              width: 100%;
              text-align: center;
            "
          >
            <span class="LOKA-Purchase-Bonus"> LOKA Purchase Bonus </span>
          </div>
          <div
            style="
              position: absolute;
              top: 124px;
              width: 100%;
              text-align: center;
            "
          >
            <span
              class="
                If-you-purchase-Rand-with-LOKA-you-can-get-additional-bonuses
              "
            >
              Purchase your Land with $LOKA<br />
              Enjoy additional bonuses depending on the amount.
            </span>
          </div>
          <div
            style="
              position: absolute;
              top: 210px;
              width: 100%;
              text-align: center;
            "
          >
            <div class="Rectangle-20-copy" @click="goLokaPurchasBonus()">
              <span class="Check-My-Bonus"> Check My Bonus </span>
              <img src="/img/icon-arr.png" class="icon_arr" />
            </div>
          </div>
        </div>
        <div
          style="
            position: absolute;
            top: 1460px;
            text-align: center;
            height: 170px;
            width: calc(100% - 40px);
            z-index: 1;
            left: 20px;
          "
        >
          <div
            class="--btn_02"
            style="position: absolute; left: 0px; top: 60px"
            @click="goLand()"
          >
            <span class="ABOUT-LAND"> ABOUT LAND 3.0 </span>
            <img src="/img/icon-arr.png" class="icon_arr" />
          </div>
          <div
            class="--btn_02"
            style="position: absolute; left: 0px; top: 150px"
            @click="goAboutMainSale()"
          >
            <span class="ABOUT-LAND"> ABOUT LAND SALE #2 </span>
            <img src="/img/icon-arr.png" class="icon_arr" />
          </div>
        </div>
      </div>
      <div
        v-if="$store.state.account.saleStatus == 'main'"
        style="text-align: center"
      >
        <div
          style="
            position: absolute;
            left: 0px;
            top: 770px;
            position: absolute;
            z-index: -2;
            background-color: #0e3a63;
            width: 100%;
            height: 380px;
          "
        ></div>
        <div
          style="
            position: absolute;
            left: 0px;
            top: 1150px;
            position: absolute;
            z-index: -2;
            background-color: #041127;
            width: 100%;
            height: 720px;
          "
        >
          <div class="--circle-11525c">
            <img src="img/icon-land.png" class="icon_land" />
          </div>
        </div>
        <div
          style="
            position: absolute;
            left: 10px;
            top: 140px;
            text-align: center;
            height: 580px;
            width: calc(100% - 20px);
          "
        >
          <div
            style="
              width: 100%;
              height: 100%;
              background-color: #090911;
              opacity: 0.7;
            "
          ></div>
          <div
            style="
              position: absolute;
              top: -10px;
              text-align: center;
              width: 100%;
            "
          >
            <span class="LAND-MAIN-SALE-2"> LAND MAIN SALE #2 </span>
          </div>
          <div
            style="
              position: absolute;
              top: 40px;
              text-align: center;
              width: 100%;
            "
          >
            <span
              class="
                Land-Main-Sale-2-will-be-open-soon-Own-the-Land-of-the-League
              "
              >Land Sale #2 (Public round) has begun.</span
            >
          </div>
          <div
            class="btn_bg"
            style="
              position: absolute;
              top: 120px;
              left: 20px;
              width: calc(100% - 40px);
              cursor: pointer;
              text-align: center;
            "
            @click="goToMainsale()"
          >
            <span class="ABOUT-LAND" style="font-size: 24px">
              Join Landsale
            </span>
            <img src="/img/icon-arr.png" class="icon_arr2" />
          </div>
          <div class="price_class" style="top: 220px;">
            <table>
              <tr height="60px">
                <th width="40%"></th>
                <th width="60%" style="color: #fff">Current</th>
                <!-- <th
                    width="150px"
                    v-for="(remainLand, index0) in remainLands"
                    v-bind:key="index0"
                  >
                    <span v-if="remainLand.remain > 0">
                      Level {{ 6 - index0 }}
                    </span>
                    <img
                      style="margin-top: -4px"
                      v-if="remainLand.remain == 0"
                      v-bind:src="`img/lv-${6 - index0}-soldout.png`"
                    />
                  </th> -->
              </tr>
              <tr
                height="60px"
                v-for="(price1, index1) in prices[0]"
                v-bind:key="index1"
              >
                <td width="40%" style="color: #ebcc1d">
                  <img
                    style="margin-top: -4px"
                    v-if="remainLands[index1].remain == 0"
                    v-bind:src="`img/lv-${6 - index1}-soldout.png`"
                  />
                  <span v-if="remainLands[index1].remain > 0"
                    >LV {{ 6 - index1 }}</span
                  >
                </td>
                <td width="60%">${{ prices[1][index1].toFixed(2) | comma }}</td>
              </tr>
            </table>
          </div>
        </div>
        <div
          style="
            position: absolute;
            top: 902px;
            text-align: center;
            height: 350px;
            width: 100%;
            z-index: 2;
          "
        >
          <div
            style="position: absolute; top: -20px; width: 100%; height: 29px"
          >
            <span class="Remaining-Time">Remaining Time</span>
          </div>
          <div style="position: absolute; top: 40px; left: calc(50% - 160px)">
            <flip-countdown
              deadtype="main-end"
              v-bind:labels="labels"
              style="
                padding-left: 0px !important;
                padding-right: 0px !important;
              "
            ></flip-countdown>
          </div>
          <div
            style="
              position: absolute;
              top: 150px;
              left: calc(50% - 150px);
              width: 300px;
              height: 40px;
            "
            class="img_salebar_bg"
          >
            <div
              v-bind:style="{
                position: 'absolute',
                top: '0px',
                left: '0px',
                overflow: 'hidden',
                height: '40px',
                width: `${saleRate * 100}%`,
              }"
            >
              <img
                src="img/img-salebar.png"
                style="
                  position: absolute;
                  top: 0px;
                  left: 0px;
                  width: 300px;
                  height: 40px;
                  max-width: none;
                "
              />
            </div>
            <span class="-Sale text-stroke"
              >{{ (saleRate * 100).toFixed(2) }}% Sold</span
            >            
          </div>          
        </div>
        
        <div
          style="
            position: absolute;
            left: 0px;
            top: 1180px;
            position: absolute;
            width: 100%;
            height: 640px;
          "
        >
          <div
            style="
              position: absolute;
              top: 50px;
              width: 100%;
              text-align: center;
            "
          >
            <span class="LOKA-Purchase-Bonus"> LOKA Purchase Bonus </span>
          </div>
          <div
            style="
              position: absolute;
              top: 124px;
              width: 100%;
              text-align: center;
            "
          >
            <span
              class="
                If-you-purchase-Rand-with-LOKA-you-can-get-additional-bonuses
              "
            >
              Purchase your Land with $LOKA<br />
              Enjoy additional bonuses depending on the amount.
            </span>
          </div>
          <div
            style="
              position: absolute;
              top: 210px;
              width: 100%;
              text-align: center;
            "
          >
            <div class="Rectangle-20-copy" @click="goLokaPurchasBonus()">
              <span class="Check-My-Bonus"> Check My Bonus </span>
              <img src="/img/icon-arr.png" class="icon_arr" />
            </div>
          </div>
        </div>
        <div
          style="
            position: absolute;
            top: 1460px;
            text-align: center;
            height: 170px;
            width: calc(100% - 40px);
            z-index: 1;
            left: 20px;
          "
        >
          <div
            class="--btn_02"
            style="position: absolute; left: 0px; top: 60px"
            @click="goLand()"
          >
            <span class="ABOUT-LAND"> ABOUT LAND 3.0 </span>
            <img src="/img/icon-arr.png" class="icon_arr" />
          </div>
          <div
            class="--btn_02"
            style="position: absolute; left: 0px; top: 150px"
            @click="goAboutMainSale()"
          >
            <span class="ABOUT-LAND"> ABOUT LAND SALE #2 </span>
            <img src="/img/icon-arr.png" class="icon_arr" />
          </div>
        </div>
      </div>
      <div
        v-if="$store.state.account.saleStatus == 'post'"
        style="text-align: center"
      >
        <div
          style="
            position: absolute;
            left: 0px;
            top: 770px;
            position: absolute;
            z-index: -2;
            background-color: #0e3a63;
            width: 100%;
            height: 450px;
          "
        ></div>
        <div
          style="
            position: absolute;
            left: 0px;
            top: 1220px;
            position: absolute;
            z-index: -2;
            background-color: #041127;
            width: 100%;
            height: 370px;
          "
        >
          <div class="--circle-11525c">
            <img src="img/icon-land.png" class="icon_land" />
          </div>
        </div>
        <div
          style="
            position: absolute;
            left: 10px;
            top: 140px;
            text-align: center;
            height: 700px;
            width: calc(100% - 20px);
          "
        >
          <div
            style="
              width: 100%;
              height: 100%;
              background-color: #090911;
              opacity: 0.7;
            "
          ></div>
          <div
            style="
              position: absolute;
              top: -10px;
              text-align: center;
              width: 100%;
            "
          >
            <span class="LAND-MAIN-SALE-2"> THANK YOU </span>
          </div>
          <div
            style="
              position: absolute;
              top: 40px;
              text-align: center;
              width: 100%;
            "
          >
            <span
              class="
                Land-Main-Sale-2-will-be-open-soon-Own-the-Land-of-the-League
              "
              >Land Main Sale #2 has ended.<br />
Thank you for participating. :)</span
            >
          </div>
          <div class="price_class" style="top: 120px;">
            <table>
              <tr height="60px">
                <th width="40%"></th>
                <th width="60%" style="color: #fff">Final</th>
                <!-- <th
                    width="150px"
                    v-for="(remainLand, index0) in remainLands"
                    v-bind:key="index0"
                  >
                    <span v-if="remainLand.remain > 0">
                      Level {{ 6 - index0 }}
                    </span>
                    <img
                      style="margin-top: -4px"
                      v-if="remainLand.remain == 0"
                      v-bind:src="`img/lv-${6 - index0}-soldout.png`"
                    />
                  </th> -->
              </tr>
              <tr
                height="60px"
                v-for="(price1, index1) in prices[0]"
                v-bind:key="index1"
              >
                <td width="40%" style="color: #ebcc1d">
                  <img
                    style="margin-top: -4px"
                    v-if="remainLands[index1].remain == 0"
                    v-bind:src="`img/lv-${6 - index1}-soldout.png`"
                  />
                  <span v-if="remainLands[index1].remain > 0"
                    >LV {{ 6 - index1 }}</span
                  >
                </td>
                <td width="60%">${{ prices[1][index1].toFixed(2) | comma }}</td>
              </tr>
            </table>
          </div>
          <div
            style="
              position: absolute;
              top: 600px;
              left: calc(50% - 150px);
              width: 300px;
              height: 40px;
            "
            class="img_salebar_bg"
          >
            <div
              v-bind:style="{
                position: 'absolute',
                top: '0px',
                left: '0px',
                overflow: 'hidden',
                height: '40px',
                width: `${saleRate * 100}%`,
              }"
            >
              <img
                src="img/img-salebar.png"
                style="
                  position: absolute;
                  top: 0px;
                  left: 0px;
                  width: 300px;
                  height: 40px;
                  max-width: none;
                "
              />
            </div>
            <span class="-Sale text-stroke"
              >{{ (saleRate * 100).toFixed(2) }}% Sold</span
            >            
          </div>     
        </div>
        
        <div
          style="
            position: absolute;
            left: 0px;
            top: 880px;
            position: absolute;
            width: 100%;
            height: 640px;
          "
        >
          <div
            style="
              position: absolute;
              top: 50px;
              width: 100%;
              text-align: center;
            "
          >
            <span class="LOKA-Purchase-Bonus"> LOKA Purchase Bonus </span>
          </div>
          <div
            style="
              position: absolute;
              top: 124px;
              width: 100%;
              text-align: center;
            "
          >
            <span
              class="
                If-you-purchase-Rand-with-LOKA-you-can-get-additional-bonuses
              "
            >
              Purchase your Land with $LOKA<br />
              Enjoy additional bonuses depending on the amount.
            </span>
          </div>
          <div
            style="
              position: absolute;
              top: 210px;
              width: 100%;
              text-align: center;
            "
          >
            <div class="Rectangle-20-copy" @click="goLokaPurchasBonus()">
              <span class="Check-My-Bonus"> Check My Bonus </span>
              <img src="/img/icon-arr.png" class="icon_arr" />
            </div>
          </div>
        </div>
        <div
          style="
            position: absolute;
            top: 1240px;
            text-align: center;
            height: 170px;
            width: calc(100% - 40px);
            z-index: 1;
            left: 20px;
          "
        >
          <div
            class="--btn_02"
            style="position: absolute; left: 0px; top: 60px"
            @click="goLand()"
          >
            <span class="ABOUT-LAND"> ABOUT LAND 3.0 </span>
            <img src="/img/icon-arr.png" class="icon_arr" />
          </div>
          <div
            class="--btn_02"
            style="position: absolute; left: 0px; top: 150px"
            @click="goAboutMainSale()"
          >
            <span class="ABOUT-LAND"> ABOUT LAND SALE #2 </span>
            <img src="/img/icon-arr.png" class="icon_arr" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { Button } from "@/components";
import { Popover } from "element-ui";
import FlipCountdown from "../components/FlipCountdown";
import config from "../config.js";
import axios from "axios";
import { connectWallet, contract } from '../utils/wallet.js';

export default {
  name: "index",
  bodyClass: "index-page",
  components: {
    [Button.name]: Button,
    [Popover.name]: Popover,
    FlipCountdown,
  },
  methods: {
    getTotalHeight() {
      if (
        this.$store.state.account.saleStatus == "post"
      ) {
        return "1510px";
      } 
      else {
        return "1860px";
      }      
    },
    getTopMargin() {
      if (
        this.$store.state.account.saleStatus == "pre"
      ) {
        return "100px";
      } else {
        return "70px";
      }
    },
    getTopMargin2() {
      if (this.$store.state.account.saleStatus == "pre") {
        return "770px";
      } else {
        return "870px";
      }
    },
    goToPresale() {
      this.$router.push("/presale");
    },
    goHomepage: async function () {
      let url = "//www.leagueofkingdoms.com" + localStorage.urlParam;
      window.open(url, "_blank");
    },
    goMainsale: async function () {
        this.$router.push("/mainsale");
    },
    goEvent() {
      this.$router.push("/event");
    },
    goAboutMainSale: function () {
      let url =
        "//medium.com/league-of-kingdoms-eng/land-sale-2-ft-land-3-0-5da9c03c1d2e";
      window.open(url, "_blank");
    },
    goLand: async function () {
      let url = "//medium.com/league-of-kingdoms-eng/land-3-0-8087a4afdcdb";
      window.open(url, "_blank");
    },
    goLokaPurchasBonus: async function () {
      if (this.$store.state.account.wallet == null) {
        this.openModal("wallet");
        return;
      }
      this.$router.push("/account/4");
    },
    goPresale: async function () {
      let url = "//link.medium.com/xN16Bo1Mp6";
      if (this.$i18n.locale == "ko") {
        url = "//link.medium.com/2l6xPJqKo6";
      } else if (this.$i18n.locale == "ch-zn") {
        //url = "//bihu.com/article/1016823935";
      }
      window.open(url, "_blank");
    },
    openModal: function (modalName) {
      this.$store.commit(`openModal`, modalName);
    },
    goToMainsale() {
      if (this.$store.state.account.wallet == null) {
        this.openModal("wallet");
        return;
      }

      this.$router.push("/mainsale");
    },
    getBannerImg() {
      if (this.$i18n.locale == "ko") {
        return "/img/event/banner_event_kr.png";
      } else if (this.$i18n.locale == "ja") {
        return "/img/event/banner_event_jp.png";
      } else if (this.$i18n.locale == "ch-zn") {
        return "/img/event/banner_event_cn.png";
      } else {
        return "/img/event/banner_event_en.png";
      }
    },
    loadLandSaleInfo: async function (zoneId, refresh) {
      let round = "sale#2";

      let ret = await axios.post(`${config.api.nft_url}/presale/lands`, {
        round: round,
        zoneId: zoneId,
        refresh: refresh,
      });

      let isStarted = ret.data.isStarted;
      let status = ret.data.status;
      let prices = ret.data.prices;
      this.prices = prices;

      this.remainLands = ret.data.landSale.sale;
      this.numTotalLand = 0;
      this.numRemainLand = 0;
      for (let i = 0; i < this.remainLands.length; ++i) {
        this.numTotalLand +=
          this.remainLands[i].total * this.remainLands[i].priceUSD;
        this.numRemainLand +=
          this.remainLands[i].remain * this.remainLands[i].priceUSD;
      }
      this.saleRate = 1 - this.numRemainLand / this.numTotalLand;

      //status = "post";
      //this.$store.commit('setPresaleStarted', isStarted);
      this.$store.commit("setSaleStatus", status);
      let products = ret.data.landSale.sale;
      let total = 0;
      let remain = 0;
      for (let i = 0; i < products.length; ++i) {
        let product = products[i];
        total += product.priceUSD * product.total;
        remain += product.priceUSD * product.remain;
      }

      if (total == 0) {
        this.rate = 0;
      } else {
        this.rate = (total - remain) / total;
        if (this.rate > 1) {
          this.rate = 1.0;
        }
      }
    },
    getLandLordDashboard: async function () {
      let round = "sale#2";

      let ret = await axios.post(
        `${config.api.nft_url}/landlord/dashboard`,
        {}
      );

      console.log("ret - ", ret);

      this.totalReward = ret.data.total;
      this.todayReward = ret.data.today;
    },
  },
  filters: {
    comma(val) {
      return String(val).replace(/\B(?<!\.\d*)(?=(\d{3})+(?!\d))/g, ",");
    },
  },
  mounted: async function () {
    await this.getLandLordDashboard(null, null);
    await this.loadLandSaleInfo(null, null);
    this.timerId = setInterval(async () => {
      await this.loadLandSaleInfo(null, true);
    }, 5 * 1000);

    await connectWallet(this.$store);

    if (this.$store.state.account.wallet != null) {
      try {
        console.log('check whitelist : ', this.$store.state.account.wallet.address);
        this.numRemainInWhiteList = await contract.methods.getWhitelist(this.$store.state.account.wallet.address).call();
      }
      catch(err) {
        this.numRemainInWhiteList = 0;  
      }
    }
    else {
      this.numRemainInWhiteList = 0;
    }
  },
  computed: {
    localeString() {
      if (this.$i18n.locale == "ko") {
        return "kr";
      } else if (this.$i18n.locale == "ch-zn") {
        return "cn";
      } else if (this.$i18n.locale == "ja") {
        return "jp";
      } else {
        return "en";
      }
    },
  },
  beforeDestroy: function () {
    if (this.timerId != null) {
      clearInterval(this.timerId);
      this.timerId = null;
    }
  },
  data: function () {
    return {
      timerId: null,
      rate: 0,
      labels: {
        days: this.$t("Days"),
        hours: this.$t("Hours"),
        minutes: this.$t("Minutes"),
        seconds: this.$t("Seconds"),
      },
      totalReward: 0,
      todayReward: 0,
      prices: [
        [0, 0, 0, 0],
        [0, 0, 0, 0],
        [0, 0, 0, 0],
      ],
      remainLands: [0, 0, 0, 0, 0, 0, 0],
      cutDevPoints: [0, 0, 0, 0, 0, 0, 0, 0, 0, 0],
      numTotalLand: 1,
      numRemainLand: 0,
      saleRate: 0,
      numRemainInWhiteList: 0
    };
  },
};
</script>
<style>
.LAND-MAIN-SALE-2 {
  width: 670px;
  height: 56px;
  background-image: linear-gradient(43deg, #cafa39 0%, #3fff7d 100%);
  font-size: 30px;
  font-weight: 900;
  font-stretch: normal;
  font-style: normal;
  line-height: 0.58;
  letter-spacing: -1.8px;
  text-align: center;
  color: #fff600;
  -webkit-background-clip: text;
  background-clip: text;
  -webkit-text-fill-color: transparent;
}

.Land-Main-Sale-2-will-be-open-soon-Own-the-Land-of-the-League {
  width: 487px;
  height: 66px;
  font-size: 12px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.67;
  letter-spacing: normal;
  text-align: center;
  color: #fff;
}

.Rectangle-22-copy-6 {
  width: 100px;
  height: 30px;
  padding: 3px 0px;
  border-radius: 12px;
  border: solid 0 #000;
  background-color: #373f51;
}

.Dutch-auction {
  width: 113px;
  height: 15px;
  font-size: 11px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.33;
  letter-spacing: -0.45px;
  text-align: center;
  color: #fff;
}

.Rectangle-22-copy-7 {
  position: absolute;
  width: calc(100% - 40px);
  height: 30px;
  left: 0px;
  top: 0px;
  opacity: 0.15;
  border-radius: 25px;
  border: solid 0 #000;
  background-color: #586780;
}

.-UTC-0000-318-UTC-2359-48-hours {
  width: 600px;
  height: 19px;
  font-size: 12px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 2.3;
  letter-spacing: -0.45px;
  text-align: left;
  color: #d7fd48;
}

.--btn_01 {
  width: 100%;
  height: 70px;
  padding-top: 20px;
  border-radius: 2px;
  border: solid 0 #fff;
  background-color: #109b99;
  cursor: pointer;
}

.ABOUT-LAND {
  width: 114px;
  height: 14px;
  margin: 0px 19px 0 0;
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #fff;
}

img.icon_arr {
  width: 7px;
  height: 12px;
  margin-bottom: 5px;
  object-fit: contain;
}

img.icon_arr2 {
  width: 7px;
  height: 12px;
  margin-bottom: 8px;
  object-fit: contain;
}

.LOKA-Purchase-Bonus {
  width: 425px;
  height: 33px;
  font-size: 24px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.05;
  letter-spacing: normal;
  text-align: center;
  color: #fff;
}

.If-you-purchase-Rand-with-LOKA-you-can-get-additional-bonuses {
  width: 554px;
  height: 56px;
  font-size: 12px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.8;
  letter-spacing: normal;
  text-align: center;
  color: #fff;
}

.Rectangle-20-copy {
  position: absolute;
  width: calc(100% - 40px);
  height: 60px;
  border-radius: 30px;
  border: solid 0 #fff;
  background-color: #063057;
  left: 20px;
  padding-top: 15px;
  cursor: pointer;
}

.Check-My-Bonus {
  width: 144px;
  height: 19px;
  font-size: 18px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: -0.45px;
  text-align: center;
  color: #fff;
  margin-right: 10px;
}

.--circle-11525c {
  width: 80px;
  height: 80px;
  border-radius: 40px;
  border: solid 0 #000;
  background-color: #11525c;
  position: absolute;
  left: calc(50% - 40px);
  top: -40px;
}

img.icon_land {
  width: 46px;
  height: 34px;
  object-fit: contain;
  position: absolute;
  left: calc(50% - 23px);
  top: calc(50% - 17px);
}

.In-the-first-24-hours-of-Land-Main-Sale-2-only-Land-of-Level {
  width: 962px;
  height: 93px;
  font-size: 12px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.8;
  letter-spacing: normal;
  text-align: center;
  color: #fff;
}

.land_class {
  width: 100%;
  height: 570px;
  border: solid 0 #000;
  background-color: #08172f;
  position: absolute;
  padding: 10px;
  top: 180px;
  left: 0px;
}

table,
tr,
td {
  border: 0px solid white !important;
}
.land_class table {
  padding: 0;
  background-color: #08172f;
  width: 100%;
}

.land_class tr {
  height: 60px;
}

.land_class th {
  padding: 0;
  border: 2px solid #08172f !important;
  background-color: #101d3c;
  height: 40px;
}

.land_class td {
  padding: 0;
  border: 2px solid #08172f !important;
  background-color: #e6eaee;
  height: 40px !important;
}
.land_class th {
  color: #39faca;
  font-size: 12px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.8;
  letter-spacing: normal;
  text-align: center;
}
.land_class td {
  color: #161720;
  font-size: 16px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: center;
}

.Main-Sale-2-Dutch-Aution-has-begun-current-price-It-is-red {
  width: 643px;
  height: 61px;
  font-size: 24px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.5;
  letter-spacing: normal;
  text-align: center;
  color: #fffffe;
}

.price_class {
  width: calc(100% - 20px);
  height: 246px;
  position: absolute;
  left: 10px;
}
.price_class table {
  padding: 0;
  width: 100%;
  background-color: #08172f;
}

.price_class tr {
  height: 60px;
}

.price_class th {
  padding: 0;
  border: 2px solid #000 !important;
  background-color: #0a1633;
  height: 60px;
}

.price_class td {
  padding: 0;
  border: 2px solid #000 !important;
  background-color: #212f50;
  height: 60px !important;
}

.price_class th {
  color: #ebcc1d;
  font-size: 14px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 2;
  letter-spacing: normal;
  text-align: center;
}
.price_class td {
  color: #a0afd2;
  font-size: 14px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: 2;
  letter-spacing: normal;
  text-align: center;
}

.Remaining-Time {
  width: 153px;
  height: 21px;
  font-size: 20px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #ffc231;
}

.img_salebar_bg {
  width: 300px;
  height: 40px;
  border-radius: 20px;
  border: solid 0 #000;
  background-color: #1f232d;
}

.-Sale {
  width: 240px;
  height: 15px;
  font-size: 18px;
  font-weight: 700;
  font-stretch: normal;
  font-style: normal;
  line-height: 2;
  letter-spacing: normal;
  text-align: center;
  color: #fff;
  position: absolute;
  top: 0px;
  left: calc(50% - 120px);
}

.btn_bg {
  width: 420px;
  height: 60px;
  padding-top: 10px;
  border-radius: 4px;
  box-shadow: 0px 4px 0 0 #005857;
  border: solid 0 #fff;
  background-color: #109b99;
}

.Land-is-an-NFT-asset-that-serves-as-the-stage-for-League-of-Kin {
  width: 613px;
  height: 92px;
  font-size: 20px;
  font-weight: 500;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.8;
  letter-spacing: normal;
  text-align: center;
  color: #fff;
}

.--btn_02 {
  width: 340px;
  height: 70px;
  padding-top: 20px;
  border-radius: 2px;
  border: solid 0 #fff;
  background-color: #26354f;
}

.text-stroke {
  text-shadow: -1px -1px 0 #000, 1.5px -1px 0 #000, -1px 1px 0 #000,
    1px 1px 0 #000;
}
</style>
